import React from 'react';
import { WA_PEDIDOS } from '../constants';

const PROMO_START = new Date('2026-06-11');
const PROMO_END = new Date('2026-06-30T23:59:59');

const BannerPromocional: React.FC = () => {
  const now = new Date();
  if (now < PROMO_START || now > PROMO_END) return null;

  return (
    <section className="w-full flex flex-col items-center justify-center py-4 px-6 text-white text-center bg-gradient-brand-diagonal">
      <h2
        className="text-[clamp(1.2rem,3.5vw,2.2rem)] font-extrabold mb-1 leading-tight uppercase tracking-wide"
        style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.5)' }}
      >
        ¡MIÉRCOLES 2X1!
      </h2>

      <p className="text-[clamp(0.85rem,1.8vw,1.1rem)] mb-0.5 font-medium opacity-95">
        Tacos de cochinita, panuchos y tortas
      </p>
      <p className="text-[clamp(0.8rem,1.5vw,0.95rem)] mb-3 opacity-85">
        Solo los miércoles — pide para llevar o a domicilio
      </p>

      <button
        onClick={() => window.open(WA_PEDIDOS, '_blank')}
        className="px-8 py-3 rounded-full border-2 border-white text-lg font-bold uppercase tracking-widest bg-white text-[#05603c] shadow-lg transition-all duration-300 hover:bg-transparent hover:text-white"
      >
        PEDIR AHORA
      </button>
    </section>
  );
};

export default BannerPromocional;
